import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsSoftwareBoardsCsmRoute: InvariantJiraRoute = {
	name: 'project-settings-software-boards-csm',
	path: '/jira/software/projects/:projectKey/settings/boards/:boardId/columns',
	exact: true,
};
